// The React half of the Mac app's protocol (native/desktop.ts). Rendered
// only in the Mac app (isMacShell), so a browser and the iPhone app never
// mount either of these.
//
//   DesktopBridge          at the root (main.tsx): `ready` once, `theme`
//                          now and on every change of the theme
//   DesktopHistoryBridge   inside the workspace's router (App.tsx): notes
//                          every navigation, which sends `history` when
//                          back / forward change

import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

import { useUi } from "@/stores/ui";

import { announceReady, announceTheme, noteNavigation } from "./desktop";

export function DesktopBridge() {
  const theme = useUi((s) => s.theme);
  useEffect(() => {
    announceTheme(theme);
  }, [theme]);
  // After the first theme message: the app knows the window's colour
  // before it hears the page is ready.
  useEffect(() => {
    announceReady();
  }, []);
  return null;
}

export function DesktopHistoryBridge() {
  const location = useLocation();
  const type = useNavigationType();
  useEffect(() => {
    noteNavigation(type);
  }, [location.key, type]);
  return null;
}
